import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import {
  formatCurrencyDecimals,
  formatNumber,
  formatNumberDecimals,
} from 'utils/formats';
import { useShareDetailsPage } from '../context/ShareDetailsPageContext';

const FinancialsCard: FC = () => {
  const { t } = useTranslate();
  const { data } = useShareDetailsPage();

  const sharesCount = data.to - data.from + 1;

  const totalValue = (data.nominalValue + data.premium) * sharesCount;

  return (
    <div className="financials">
      <div className="financials__stats">
        <div className="financials__stat">
          <p className="financials__stat-label">{t('Nominal')}</p>
          <p className="financials__stat-value">
            {formatNumberDecimals(data.nominalValue)}
          </p>
        </div>
        <div className="financials__stat">
          <p className="financials__stat-label">{t('SharePrice')}</p>
          <p className="financials__stat-value">
            {formatCurrencyDecimals(data.price)}
          </p>
        </div>
        <div className="financials__stat">
          <p className="financials__stat-label">{t('Premium')}</p>
          <p className="financials__stat-value">
            {formatCurrencyDecimals(data.premium)}
          </p>
        </div>
      </div>

      <div className="financials__total">
        <p className="financials__total-label">
          {`${t('TotalValue')} (${formatNumber(sharesCount)} ${t('shares')})`}
        </p>
        <p className="financials__total-value">
          {formatCurrencyDecimals(totalValue)}
        </p>
      </div>
    </div>
  );
};

export default FinancialsCard;
